import { createAction } from '@reduxjs/toolkit';

export const showLoader = createAction('loader/showLoader');
export const hideLoader = createAction('loader/hideLoader');
